module.exports = __webpack_public_path__ + "static/media/delete.4ba2d732.svg";